import React from 'react';
import { FaChevronLeft, FaChevronRight } from 'react-icons/fa';
import styles from './styles/HeroNavigation.module.css';

/**
 * Componente de navegación (botones prev/next)
 * @param {Function} onPrev - Handler para botón anterior
 * @param {Function} onNext - Handler para botón siguiente
 * @param {boolean} showPrev - Mostrar botón anterior
 * @param {boolean} showNext - Mostrar botón siguiente
 */
const HeroNavigation = ({ 
  onPrev, 
  onNext, 
  showPrev = true, 
  showNext = true 
}) => {
  return (
    <>
      {showPrev && (
        <button 
          className={`${styles.navButton} ${styles.prevButton}`}
          onClick={onPrev}
          aria-label="Slide anterior"
        >
          <FaChevronLeft />
        </button>
      )}
      {showNext && (
        <button 
          className={`${styles.navButton} ${styles.nextButton}`}
          onClick={onNext}
          aria-label="Siguiente slide"
        >
          <FaChevronRight />
        </button>
      )}
    </>
  );
};

export default HeroNavigation;
